import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { Section } from 'common';
import { filterValidItems, isTruthyValue } from 'utils';

import { DescriptionText } from '../../styles';
import { formatPeriod } from '../../utils';

import { CapitalizedText } from './OrganizationalExperienceSection.styled';

export const OrganizationalExperienceSection = ({ title, items = [] }) => {
  const validItems = filterValidItems(items);
  if (validItems.length === 0) return null;

  return (
    <Section title={title}>
      <List disablePadding>
        {validItems.map(item => {
          const {
            issuing_organization: issuingOrganization,
            organization,
            role,
            start_date: startDate,
            end_date: endDate,
            description
          } = item;

          const period = [startDate, endDate].filter(Boolean);
          const formattedPeriod = period.map(formatPeriod);
          const finalOrganization = issuingOrganization || organization;

          return (
            <ListItem key={role} disableGutters>
              <ListItemText
                primary={
                  <>
                    {isTruthyValue(finalOrganization) && (
                      <Typography color="textSecondary">{finalOrganization}</Typography>
                    )}
                    {isTruthyValue(role) && (
                      <CapitalizedText>
                        <b>{role}</b>
                      </CapitalizedText>
                    )}

                    {isTruthyValue(description) && (
                      <DescriptionText color="textSecondary" component="pre">
                        {description}
                      </DescriptionText>
                    )}

                    {isTruthyValue(formattedPeriod) && (
                      <Typography color="textSecondary">{formattedPeriod.join(' - ')}</Typography>
                    )}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Section>
  );
};
